export const MIGRATION_TYPES = {
  email: 'email',
  percentage: 'percentage',
} as const;
export const MIGRATION_EMAIL_TYPES = {
  account: 'account',
  user: 'user',
} as const;
